import React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import {connect} from "react-redux";
import {withRouter} from "react-router";
import Form from "./TransferActionForm";
import {cancelDiscardStockTransfer, successDiscardStockTransfer} from "../../../actions/StockTransferApiActions";
import {createValidationErrors, createErrors} from "../../../lib/ErrorFormatter";

// Takes a transfer cancelled by mistake out of view. The backend keeps its
// history; it only leaves the lists.
class DiscardStockTransferFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit() {
    return this.props.discardStockTransfer({transferId: this.props.transferId})
      .then((response) => {
        if (response.data.discardStockTransfer.errors.length <= 0) {
          this.props.successDiscardStockTransfer();
          this.props.router.push("/stock-transfers");
        } else {
          let errors = createValidationErrors(response.data.discardStockTransfer.errors,
            response.data.discardStockTransfer.errors.map((error) => error.message).join("\n"));
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });
  }

  handleCancel() {
    this.props.cancelDiscardStockTransfer();
  }

  render() {
    return (
      <Form
        errors={this.state.errors}
        submitLabel="Delete Transfer"
        message="Delete this cancelled transfer? It disappears from the transfer lists. Use this for a transfer made by mistake."
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const DISCARD_STOCK_TRANSFER = gql`
  mutation discardStockTransfer($data: DiscardStockTransferInput!) {
    discardStockTransfer(input: $data) {
      errors { key message }
    }
  }
`;

const withMutation = graphql(DISCARD_STOCK_TRANSFER, {
  props: ({ mutate }) => ({
    discardStockTransfer: (data) => mutate({
      variables: { data: data },
      refetchQueries: ["stockTransfers"]
    })
  })
});

export default connect(null, {cancelDiscardStockTransfer, successDiscardStockTransfer})(withRouter(withMutation(DiscardStockTransferFormContainer)));
